module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page auth-page auth-twitter-confirm-page"
  }, [_c('v-card', {
    attrs: {
      "mt-5": ""
    }
  }, [_c('v-card-media', {
    attrs: {
      "contain": "",
      "src": "/static/images/ic_twitter.png",
      "height": "50px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Connect to Twitter")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n      To complete verification, you must login to your Artist, Brand, or\n      Label"), _c('br'), _vm._v("\n      Twitter account once time & verify your identity.\n    ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "dark": "",
      "color": "blue",
      "px-4": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Login to Twitter")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e9a2890","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/twitter_confirm.vue
// module id = 1822
// module chunks = 180